import ThankYouImage from 'assets/images/about-us/thank-you.jpg';
import Image from 'components/image';
import { PROD_BASE_URL } from 'helpers/constant';
import React from 'react';
import { genImageAltText } from 'utils/genImageAltText';

export const ThankYouTab: React.FC = () => {
  return (
    <div className='w-full flex space-x-8'>
      <ul className='flex-1 space-y-3 text-lg text-justify list-inside'>
        <li className='indent-6'>
          <a href={PROD_BASE_URL} className='font-medium link'>
            Celestial Relics
          </a>{' '}
          xin kính chào, được quý khách hàng và đối tác lựa chọn là một niềm vinh hạnh đối với chúng tôi. Điều đó cho thấy sự tin tưởng vào dịch vụ và
          sản phẩm của{' '}
          <a href={PROD_BASE_URL} className='font-medium link'>
            Celestial Relics
          </a>
          . Mang lại giá trị tốt nhất cho khách hàng thông qua những tu vấn sản phẩm cụ thể, hữu ích và khách quan, là điều kiện tiên quyết mà chúng
          tôi cần đạt được; nhằm duy trì niềm tin của khách hàng cũ, mở ra cơ hội hợp tác với khách hàng mới cũng như củng cố uy tín, sự vững chắc của
          tổ chức.
        </li>
        <li className='indent-6'>
          Chúng tôi cũng hiểu rằng, với mỹ phẩm thì độ hiệu quả và sự an toàn sức khỏe của khách hàng là tài sản lớn nhất của công ty. Do vậy mỗi cá
          nhân thuộc Ban lãnh đạo cũng như nhân viên cam kết luôn đặt lợi ích của khách hàng lên hàng đầu. Lấy triết lý kinh doanh đặt khách hàng là
          trọng tâm, chúng tôi sẽ không ngừng cải thiện để nâng cao chất lượng sản phẩm, dịch vụ để mang đến cho tất cả sự trải nghiệm về sản phẩm tốt
          nhất nhằm đáp lại sự tin tưởng của mọi người dành cho{' '}
          <a href={PROD_BASE_URL} className='font-medium link'>
            Celestial Relics
          </a>
          .
        </li>
        <li className='indent-6'>
          Với mục tiêu xây dựng và phát triển thương hiệu uy tín, chất lượng, luôn đặt lợi ích của quý khách hàng và đối tác lên hàng đầu. Sự yêu mến,
          hỗ trợ của quý đối tác chính là thành tựu lớn nhất mà chúng tôi đạt được. Song hành cùng đấy, chúng tôi luôn tiến tới việc xây dựng một hệ
          sinh thái cùng nhau phát triển, được đồng hành cùng quý khách hàng và đối tác thật là niềm vinh dự lớn lao.
        </li>
        <li className='indent-6'>
          <a href={PROD_BASE_URL} className='font-medium link'>
            Celestial Relics
          </a>{' '}
          chân thành cảm ơn đã lựa chọn sản phẩm Elixir. Hy vọng rằng chất lượng mà sản phẩm mang lại sẽ làm hài lòng và vượt được ngưỡng kì vọng của
          tất cả mọi người.
        </li>
        <li className='indent-6'>Thật tuyệt vời khi có một khách hàng như bạn.</li>
        <li className='indent-6'>
          Mong rằng{' '}
          <a href={PROD_BASE_URL} className='font-medium link'>
            Celestial Relics
          </a>{' '}
          sẽ được tiếp tục phục vụ trong những lần sau.
        </li>
        <li className='flex justify-end'>
          <p className='w-fit text-center space-y-2'>
            <span className='block italic'>Trân trọng</span>
            <span className='block  text-xl italic font-semibold'>
              <a href={PROD_BASE_URL} className='font-medium link'>
                Celestial Relics
              </a>
            </span>
          </p>
        </li>
      </ul>
      <div className='shrink-0 w-full hidden lg:block lg:max-w-sm'>
        <Image src={ThankYouImage} alt={genImageAltText('Lời cảm ơn')} className='w-full h-auto object-contain' />
      </div>
    </div>
  );
};
